<template>
  <header>
    <v-toolbar class="app-header elevation-0" fixed app>
      <template v-if="role !== 3">
        <router-link tag="div" :to="{ name: 'currentEvent' }">
          <v-toolbar-title>
              <div class="logo-img">
                <img draggable="false" src="~@/assets/logo.png">
              </div>
            <span>{{ ['suitesManager', 'suitesList', 'suitesGroups', 'suitesGroupsManager'].includes($route.name) ? 'Suite Remote Control' : 'Messaging Application' }}</span>
          </v-toolbar-title>
        </router-link>
      </template>
      <template v-else>
        <div>
          <v-toolbar-title>
              <div class="logo-img">
                <img draggable="false" src="~@/assets/logo.png">
              </div>
            <span>{{ ['suitesManager', 'suitesList', 'suitesGroups', 'suitesGroupsManager'].includes($route.name) ? 'Suite Remote Control' : 'Messaging Application' }}</span>
          </v-toolbar-title>
        </div>
      </template>
      <v-spacer></v-spacer>  
      <v-toolbar-items>
        <router-link 
          v-if="$route.name === 'currentEvent'"
          tag="v-btn" 
          class="btn--flat hidden-sm-and-down" 
          :to="{ name: 'sectionMessagesAll' }">
          <v-icon color="primary" class="nav-icons">edit</v-icon>
          Messages List
        </router-link>
        <router-link 
          v-if="['tv', 'tablet', 'remote', 'group', 'section', 'currentEvent'].includes($route.name)"
          tag="v-btn" 
          class="btn--flat hidden-sm-and-down" 
          :to="{ name: 'eventManager' }">
          <v-icon color="primary" class="nav-icons">settings</v-icon>
          Settings
        </router-link>
        <router-link 
          tag="v-btn" 
          class="btn--flat" 
          v-if="$route.name !== 'currentEvent' && role !== 3"
          :to="{ name: 'currentEvent' }">
          <v-icon color="primary" class="nav-icons">home</v-icon>
          Home
        </router-link>
        <v-menu 
          v-if="$route.name !== 'logIn' && $route.name !== 'forgotPassword' && $route.name !== 'newPassword'"
          transition="slide-y-transition">
          <v-toolbar-side-icon slot="activator"><v-icon color="primary">person</v-icon></v-toolbar-side-icon>
           <v-list class="list-adj">  
            <v-btn
              class="btn--flat"  
              @click="logout()"
              ><v-icon color="primary" class="nav-icons" left light>exit_to_app</v-icon>
              Logout
            </v-btn>
            <v-btn
              class="btn--flat"
              v-if="role !== 3"
              :to="{ name: 'profile' }">
              <v-icon color="primary" class="nav-icons" left light>edit</v-icon>
              Edit Profile
            </v-btn>
           </v-list>
        </v-menu>
        <v-menu v-if="$route.name === 'currentEvent'" transition="slide-y-transition">
          <v-toolbar-side-icon class="hidden-md-and-up" slot="activator"></v-toolbar-side-icon>
          <v-list class="list-adj">
            <router-link tag="v-btn" class="btn--flat" :to="{ name: 'sectionMessagesAll' }"><v-icon color="primary" class="nav-icons">edit</v-icon>Section Messages</router-link>
            <router-link tag="v-btn" class="btn--flat" :to="{ name: 'eventManager' }"><v-icon color="primary" class="nav-icons">settings</v-icon>Settings</router-link>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
  </header>
</template>

<script>
  import { mapGetters } from 'vuex';
  import webHelper from '../../helpers/web';

  export default {
    methods: {
      async logout() {
        const path = process.env.NODE_ENV === 'development' ?
          'http://localhost:3000/logout' : '/logout';
        await webHelper.post(this, path, {});
        this.$store.state.logout();
        this.$store.dispatch('setRole', null);
        this.$router.push({ name: 'logIn' });
      },
    },
    computed: mapGetters({ role: 'role' }),
  };
</script>

<style lang="scss">
  .app-header {
    background-color: #fff !important;
    border-bottom: 3px solid #f57f17;
  }
  .btn--icon {
    border-radius: 0 !important;
    .btn__content:before {
      border-radius: 0 !important;
    }
  }
  @media only screen and (max-width: 599px) {
    .list-adj {
      max-width: 225px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/Header.vue